<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <line-chart :chartData="datasets" :options="options"></line-chart>
      </div>
      <div class="md-layout-item">
        <line-chart :chartData="sum" :options="options"></line-chart>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-table>
          <md-table-row>
            <md-table-head>日期</md-table-head>
            <md-table-head>人際</md-table-head>
            <md-table-head>個人</md-table-head>
            <md-table-head>社會</md-table-head>
            <md-table-head>整體</md-table-head>
          </md-table-row>
          <md-table-row v-for="(orsTest, index) in orsTests" :orsTests="orsTests" :key="index">
            <md-table-cell>
              {{formatDate(orsTest.record.date)}}
            </md-table-cell>
            <md-table-cell>
              {{orsTest.content.interpersonal}}
            </md-table-cell>
            <md-table-cell>
              {{orsTest.content.personal}}
            </md-table-cell>
            <md-table-cell>
              {{orsTest.content.social}}
            </md-table-cell>
            <md-table-cell>
              {{orsTest.content.overall}}
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Patient/LineChart'
import axios from 'axios'
import urls from '@/urls'
import moment from 'moment'

export default {
  props: ['patientID'],
  data () {
    return {
      orsTests: [],
      sum: [],
      datasets: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            ticks: {
              source: 'data'
            },
            time: {
              unit: 'day',
              unitStepSize: 1,
              round: true,
              displayFormats: {
                'day': 'YYYY/MM/DD'
              }
            }
          }]
        }
      }
    }
  },
  components: {
    LineChart
  },
  mounted () {
    this.getPatientORS(this.patientID)
  },
  methods: {
    formatDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    async getPatientORS (patientID) {
      let req = await axios.get(urls({route: 'ors-test/by-patient', id: patientID}))
      this.orsTests = req.data.data

      let interpersonal = []
      let personal = []
      let social = []
      let overall = []
      let sum = []

      for (var i in this.orsTests) {
        let test = this.orsTests[i]
        let date = moment(test.record.date).format('YYYY-MM-DD')
        sum.push({
          y: test.content.interpersonal + test.content.personal + test.content.social + test.content.overall,
          x: date
        })
        interpersonal.push({
          y: test.content.interpersonal,
          x: date
        })
        personal.push({
          y: test.content.personal,
          x: date
        })
        social.push({
          y: test.content.social,
          x: date
        })
        overall.push({
          y: test.content.overall,
          x: date
        })
      }
      this.sum = {
        type: 'line',
        datasets: [
          {
            label: '總分',
            backgroundColor: '#ff0000',
            fill: false,
            data: sum
          }
        ]
      }
      this.datasets = {
        type: 'line',
        datasets: [
          {
            label: '人際',
            backgroundColor: '#ff0000',
            fill: false,
            data: interpersonal
          },
          {
            label: '個人',
            backgroundColor: '#00ff00',
            fill: false,
            data: personal
          },
          {
            label: '社會',
            backgroundColor: '#0000ff',
            fill: false,
            data: social
          },
          {
            label: '整體',
            backgroundColor: '#0f0f0f',
            fill: false,
            data: overall
          }
        ]
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Patient/OrsCharts.vue